export const NUMBERS_BUTTONS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
export const MESSAGES = {
  MAX_LIMIT: 'Este monto excede el máximo posible de RD $65,100.00',
  MIN_LIMIT: 'El monto debe ser mayor o igual a RD $2.50',
};
export const AMOUNT = {
  MAX_LIMIT: 65100,
  MIN_LIMIT: 2.5,
};
